import React, { useCallback, useContext, useState } from "react";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { UI } from "@wwimmo/ui";
import styles from "./AgendaItemUnlockModal.module.css";
import { RootStoreContext } from "src/stores/RootStore";

const AgendaItemUnlockModalBase = () => {
    const { t } = useTranslation();
    const { agendaitemStore, assemblyStore } = useContext(RootStoreContext);
    const [isFirstClick, setIsFirstClick] = useState(true);

    const onCloseUnlockModal = useCallback(() => {
        agendaitemStore.setIsModalUnlockDisplayed(false);
        setIsFirstClick(true); // Reset state on close
    }, [agendaitemStore]);

    const onClickOkButton = useCallback(() => {
        if (isFirstClick) {
            setIsFirstClick(false);
        } else {
            assemblyStore.updateAssemblyState(1);
            agendaitemStore.deleteAssemblyProtocolFiles();
            agendaitemStore.setIsModalUnlockDisplayed(false);
            setIsFirstClick(true);
        }
    }, [isFirstClick, agendaitemStore, assemblyStore]);

    const firstModalContent = (
        <>
            <div className={styles.ModalTitle}>{t("screens.assemblies.agenda.modal.title")}</div>
            <div className={styles.ModalSubtitle}>{t("screens.assemblies.agenda.modal.subtitle1")}</div>
            <ul>
                <li>{t("screens.assemblies.agenda.modal.protocol_publish")}</li>
                <li>{t("screens.assemblies.agenda.modal.protocol_download")}</li>
            </ul>
            <div>{t("screens.assemblies.agenda.modal.protocol_republish")}</div>
        </>
    );

    const secondModalContent = (
        <>
            <div className={styles.ModalTitle}>{t("screens.assemblies.agenda.modal.title")}</div>
            <div className={styles.ModalSubtitle}>{t("screens.assemblies.agenda.modal.subtitle2")}</div>
        </>
    );

    return (
        <UI.Modal show={agendaitemStore.isModalUnlockDisplayed} isScrollable={true} centered>
            {isFirstClick ? firstModalContent : secondModalContent}
            <div className={"d-flex justify-content-end mt-2"}>
                <UI.Button
                    label={t("labels.cancel")}
                    className={styles.ModalButtonCancel}
                    onClick={onCloseUnlockModal}
                />
                <UI.Button
                    label={t("labels.ok").toUpperCase()}
                    className={styles.ModalButtonOk}
                    onClick={onClickOkButton}
                />
            </div>
        </UI.Modal>
    );
};

export const AgendaItemUnlockModal = Sentry.withProfiler(observer(AgendaItemUnlockModalBase));
